import Search from "@client/controls/Inputs/Search/component";
import classnames from "classnames";
import React from "react";

import "./style.less";

export type ExpandableSearchMapProps = {
  className?: string;
  debounceMs?: number;
  placeholder?: string;
  style?: React.CSSProperties;
  value?: string | null;
};

export interface ExpandableSearchActionProps {
  onClear?: () => void;
  onSearch?: (text: string) => void;
}

interface State {
  isExpanded: boolean;
  text: string;
}
export default class ExpandableSearch extends React.PureComponent<
  ExpandableSearchMapProps & ExpandableSearchActionProps,
  State
> {
  public state: State = {
    isExpanded: false,
    text: this.props.value ?? ""
  };

  public componentDidUpdate(
    prevProps: Readonly<ExpandableSearchMapProps & ExpandableSearchActionProps>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    if (prevProps.value !== this.props.value) {
      this.setState({ text: this.props.value ?? "" });
    }
  }

  public render() {
    const props = this.props;
    return (
      <Search
        className={classnames(props.className, "expandable_search", { expanded: this.state.isExpanded })}
        iconPosition="right"
        onBlur={this._onBlur}
        onChange={this._onChange}
        onChangeDelay={props.debounceMs}
        onClear={props.onClear}
        onFocus={this._onFocus}
        placeholder={props.placeholder}
        style={props.style}
        value={this.state.text}
      />
    );
  }

  private _onBlur = () => {
    this.setState({ isExpanded: false });
  };

  private _onChange = (text: string) => {
    this.setState({ text });

    this.props.onSearch && this.props.onSearch(text);
  };

  private _onFocus = () => {
    this.setState({ isExpanded: true });
  };
}
